// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3eq-L","label":"Completed_label__UTGPz"};